import React, { FC } from 'react'
import Icon from '../../atoms/icon/Icon'
import { IconType } from 'lib/helpers/constants/iconTypes'
import { useTranslation } from 'react-i18next';


export interface IUploadedFileProps {
    title: string;
    icon: IconType;
    size?: string;
    updatedate?: string;
    link?: string;
    isEditable?: boolean;
    dropdown?: React.ReactElement;
    linkName?: string;
    deleteIcon?: React.ReactElement;
    isAudio?: boolean;
    fullLink?: string;
}


const UploadedFile: FC<IUploadedFileProps> = ({
    title,
    icon,
    size,
    updatedate,
    link,
    isEditable = true,
    deleteIcon,
    linkName,
    isAudio,
    fullLink
}) => {

    //   http://127.0.0.1:8000/api/costumers/quality/audio/file_example_MP3_700KB_67ee87ca7437a.mp3


    const openPreviewFile = () => {
        if(fullLink) {
            window.open(`${process.env.REACT_APP_API_URL}${fullLink}`)
            return
        }
        window.open(
            `${process.env.REACT_APP_API_URL}${linkName}/${isAudio ? 'audio' : 'document'}/${link}`
        )
    }
    const { t } = useTranslation();

    return (
        <div className='bg-white border borber-border px-4 lg:px-6 py-4 rounded-[8px]'>
            <div className="flex flex-row gap-5 items-center flex-wrap justify-between">
                <div className="flex-none">
                    {link ?
                        <div onClick={openPreviewFile} className='cursor-pointer'>
                            <Icon iconType={icon} color="#50B8E7" />
                        </div>
                        :
                        <div>
                            <Icon iconType={icon} color="#50B8E7" />
                        </div>
                    }

                </div>
                <div className="flex-1">

                    {link ?
                        <div onClick={openPreviewFile} className='cursor-pointer'>
                            <div className='font-inter-medium text-sm text-primaryTextColor'>

                                <span>{title}</span>
                            </div>
                        </div>
                        :
                        <div className='font-inter-medium text-sm text-primaryTextColor'>

                            <span>{title}</span>
                        </div>
                    }
                    <div className='text-sm font-inter-regular text-secondaryTextColor'>
                        <span>{size}</span>
                    </div>
                </div>
                {
                    updatedate && (
                        <div className="flex-none">
                            <span className='text-xs font-inter-medium text-secondaryTextColor'>{t('Created at')} {updatedate}</span>
                        </div>
                    )
                }
                {
                    (isEditable && deleteIcon) && (
                        <div className="flex-none relative">
                            {deleteIcon}
                        </div>
                    )
                }
                {
                    isAudio && (
                        <div onClick={openPreviewFile} className="flex-none cursor-pointer">
                            <Icon iconType={IconType.PLAY_ICON} />
                        </div>
                    )
                }
            </div>
        </div >
    )
}

export default UploadedFile